import {
  AmplitudeContext,
  AmplitudeEventConstants,
} from '@homebot/shared-util-quartermaster'
import { useContext } from 'react'
import * as Sentry from '@sentry/browser'
import { PmiStepEnum } from '../PmiEstimatedModule'
import { useIntl, defineMessages } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../types/rootState'
import { updateHomeLoan } from '../../../../actions/home'
import { selectHomeId } from '../../../../store/selectors/home'
import { Button, ButtonGroup } from '@homebot/shared-ui-swashbuckle'

export const MSG = defineMessages({
  yes: {
    id: 'General.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'General.no',
    defaultMessage: 'No',
  },
  unsure: {
    id: 'General.unsure',
    defaultMessage: 'Unsure',
  },
})

export interface PmiEstimatedInitialStepProps {
  setStep: (step: PmiStepEnum) => void
  setInProgress: (inProgress: boolean) => void
}

export const PmiEstimatedInitialStep = ({
  setStep,
  setInProgress,
}: PmiEstimatedInitialStepProps) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const homeId = useSelector(selectHomeId)
  const { ampli } = useContext(AmplitudeContext)
  const currentLoanId = useSelector<RootState, string | null>(
    state => state.pmi.estimatedLoanId
  )

  const handleYesClick = () => {
    ampli?.pmiChecked({
      pmi_quick_check: AmplitudeEventConstants.PMI_QUICK_CHECK_YES,
    })

    setStep(PmiStepEnum.InputStep)
  }

  const handleNoClick = () => {
    ampli?.pmiChecked({
      pmi_quick_check: AmplitudeEventConstants.PMI_QUICK_CHECK_NO,
    })

    setInProgress(true)
    setStep(PmiStepEnum.MortgageStep)

    try {
      return dispatch(
        updateHomeLoan({
          pmiMonthly: 0,
          homeId: homeId,
          loanUuid: currentLoanId,
        })
      )
    } catch (e) {
      console.error(e)
      return Sentry.captureException(e)
    }
  }

  const handleUnsureClick = () => {
    ampli?.pmiChecked({
      pmi_quick_check: AmplitudeEventConstants.PMI_QUICK_CHECK_UNSURE,
    })

    setStep(PmiStepEnum.DmStep)
  }

  return (
    <ButtonGroup width='100%' maxWidth='25rem'>
      <Button flex='1 1 5rem' onClick={handleYesClick}>
        {intl.formatMessage(MSG.yes)}
      </Button>
      <Button flex='1 1 5rem' onClick={handleNoClick}>
        {intl.formatMessage(MSG.no)}
      </Button>
      <Button flex='1 0 5rem' onClick={handleUnsureClick}>
        {intl.formatMessage(MSG.unsure)}
      </Button>
    </ButtonGroup>
  )
}
